// src/data/site.js
export const site = {
  brand: "konbayan",
  nav: [
    { label: "Home", to: "/" },
    { label: "Activities + FAQ", to: "/paket-faq" },
    { label: "Contact", to: "/contact" },
  ],
  socials: [{ label: "Instagram", href: "https://www.instagram.com/konbayan/" }],
  contact: {
    whatsapp: "+62 819-5261-0278",
    meetPoint: "Konbayan Espresso & Farm (Bayan / Senaru)",
  },
};
